import { Component, ViewChild  } from '@angular/core';
import { NavController, NavParams,Nav,LoadingController } from 'ionic-angular';

//types
import {PageInterface} from '../model/types';

//page
import { TabsPage } from '../tabs/tabs';
import { CategoryPage } from '../category/category';
import { OrderPage } from '../order/order';
import { ProfilePage } from '../profile/profile';
import { LogoutPage } from '../logout/logout';
import { ContactPage } from '../contact/contact';
import { OfferPage } from '../offer/offer';
import { AddressPage } from '../address/address';
import { AboutPage } from '../about/about';
// import { WalletPage } from '../wallet/wallet';

@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html'
})
export class MenuPage {

  //class variable
  rootPage:any = TabsPage;
 
  @ViewChild(Nav) nav :Nav;

 pages : PageInterface[]=[
    {title:"Home",icon:"home",pageName:"ListMenu",index:0,tabComponent:"HomePage"},
    {title:"Shop By Category",icon:"swap",pageName:"ListMenu",index:1,tabComponent:"CategoryPage"},
    {title:"My Order",icon:"pizza",pageName:"ListMenu",index:2,tabComponent:"OrderPage"},
    {title:"My Account",icon:"settings",pageName:"ListMenu",index:3,tabComponent:"ProfilePage"},
    {title:"My Offer",icon:"cloud",pageName:"ListMenu",index:4,tabComponent:"OfferPage"},
    {title:"Manage Address",icon:"call",pageName:"ListMenu",index:5,tabComponent:"AddressPage"},
    // {title:"My Wallet",icon:"text",pageName:"ListMenu",index:6,tabComponent:"WalletPage"},
    {title:"Feedback",icon:"text",pageName:"ListMenu",index:6,tabComponent:"ContactPage"},
    {title:"About us",icon:"contact",pageName:"ListMenu",index:7,tabComponent:"AboutPage"},
    {title:"Logout",icon:"trash",pageName:"ListMenu",index:8,tabComponent:"LogoutPage"},
 ];

 // constructor
  constructor(public navCtrl: NavController,public navParams: NavParams,public loadingCtrl : LoadingController) {
  }
  ionViewDidEnter(){
    let categoryId = this.navParams.data.categoryId || 0;
    let subCategoryId = this.navParams.data.subCategoryId || 0;
    let brandId = this.navParams.data.brandId || 0;
    let productTypeId = this.navParams.data.productTypeId || 0;
    let vendorId=this.navParams.data.vendorId || 0;

    if(categoryId!=0 || subCategoryId!=0){
      this.nav.setRoot(TabsPage,
                              {
                                categoryId:categoryId,
                                subCategoryId:subCategoryId,
                                brandId:brandId,
                                productTypeId:productTypeId,
                                vendorId:vendorId
                              });
      this.rootPage=TabsPage;  
    }
  }
  // open specific page
  
  openPage(page:PageInterface){   
    if(page!=undefined){

        this.AddFalseLoadingBar();
        
        if(page.tabComponent.toLowerCase()=="categorypage"){
          this.nav.push(CategoryPage);
          //this.nav.setRoot(CategoryPage);
          //this.rootPage=CategoryPage;
        }
        else if(page.tabComponent.toLowerCase()=="orderpage"){
          this.navCtrl.push(OrderPage);
          //this.nav.setRoot(OrderPage);
          //this.rootPage=OrderPage;
        }
        else if(page.tabComponent.toLowerCase()=="profilepage"){
          this.navCtrl.push(ProfilePage);
        }
        else if(page.tabComponent.toLowerCase()=="offerpage"){
          this.navCtrl.push(OfferPage);
        }
        else if(page.tabComponent.toLowerCase()=="contactpage"){
          this.navCtrl.push(ContactPage);
        }
        else if(page.tabComponent.toLowerCase()=="addresspage"){
          this.navCtrl.push(AddressPage);
          //this.navCtrl.setRoot(AddressPage);
        }
        else if(page.tabComponent.toLowerCase()=="logoutpage"){
          this.navCtrl.setRoot(LogoutPage);
        }
        else if(page.tabComponent.toLowerCase()=="aboutpage"){
          this.navCtrl.push(AboutPage);
        }
        // else if(page.tabComponent.toLowerCase()=="walletpage"){
        //   this.navCtrl.push(WalletPage);
        // }      
        else
        {
          this.rootPage=TabsPage;
        }
    }
  }

  AddFalseLoadingBar(){

    //create loader
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
  
    //show loader
    loading.present();

    setTimeout(function(){
      loading.dismiss();
    },1000);
   }

}




// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts